import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

const variables = [
  { token: '{{docNum}}', label: 'Bizonylatszám' },
  { token: '{{companyName}}', label: 'Partner neve' },
  { token: '{{DocDate}}', label: 'Dátum' },
  { token: '{{issueDate}}', label: 'Bizonylat dátuma' },
  { token: '{{dueDate}}', label: 'Esedékesség dátuma' },
  { token: '{{reference}}', label: 'Hivatkozási szám' },
  { token: '{{userName}}', label: 'Küldő felhasználó neve' },
  { token: '{{userEmail}}', label: 'Küldő felhasználó e-mail címe' },
];

const SmsTemplateVariablePanel = ({ disabled, onInsertVariable }) => (
  <Box className="col-span-6" sx={{ mt: 2 }}>
    <Typography variant="subtitle2">Sablonváltozók</Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
      A változók küldéskor a bizonylat adataival kerülnek behelyettesítésre.
    </Typography>
    <Box display="flex" flexWrap="wrap" gap={1}>
      {variables.map(({ token, label }) => (
        <Chip
          key={token}
          label={`${label}: ${token}`}
          disabled={disabled}
          onMouseDown={(event) => event.preventDefault()}
          onClick={() => onInsertVariable(token)}
        />
      ))}
    </Box>
  </Box>
);

export default SmsTemplateVariablePanel;
